import _default from './Loader';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Loader/index.js
// module id = 1761
// module chunks = 0